const APIURL = {
  //登录注册
  register:'/api/gsUser/register',// 注册
}
export default APIURL
